import React from "react";

const EllipsisLoading = ({ text }: { text: string }) => {
  const [dots, setDots] = React.useState("");

  React.useEffect(() => {
    const interval = setInterval(() => {
      setDots((prevDots) => (prevDots.length < 3 ? prevDots + "." : ""));
    }, 200);

    return () => { clearInterval(interval); };
  }, []);

  return (
    <div>
      {text}{dots}
    </div>
  );
};

export default EllipsisLoading;